<div class="row">
  <div class="col-12">
    <h1 class="page-title">{{pageTitle}}</h1>
    <p>{{pageDescription}}</p>
    @if (!(getInterestsloading$ | async)) {
      @if (interests$ | async; as products) {
        @for (result of products?.results; track result) {
          <div class="wrapper-elements">
            <a tabindex="0" [routerLink]="{ cxRoute: 'product', params: result.product } | cxUrl"
              class="d-flex align-items-center w-50 link-product">
              <cx-media [container]="result.product.images?.PRIMARY" format="product"></cx-media>
              <div class="ml-3">
                <div class="cx-manufacturer">
                  {{result.product.manufacturer }}
                </div>
                @if (result.product.name) {
                  <div class="cx-name d-block">
                    {{ result.product.nameHtml }}
                  </div>
                }
                <div class="price" aria-label="new item price">
                  {{ result.product.price?.formattedValue }}
                  @if (result.product?.price?.discountValue) {
                    <span class="old-price">{{ result.product?.price?.originalPrice.formattedValue}}</span>
                    <span class="discount">{{ result.product?.price?.discountPercentage }}</span>
                  }
                </div>
              </div>
            </a>
            <div class="info-stock">
              @if (result.product.stock.purchasable) {
                {{'saveForLaterItems.forceInStock' | cxTranslate}}
              } @else {
                @for (stock of result.productInterestEntry; track stock) {
                  <div class="subscription"> {{'saveForLaterItems.dateSubscription' | cxTranslate}} {{stock.dateAdded |
                  dateEs}}</div>
                  <div class="reception"> {{'saveForLaterItems.dateReception' | cxTranslate}}
                  {{result.product?.stock?.message}}</div>
                }
              }
            </div>
            <app-custom-icons (click)="removeProductOfNotifyMe(result.product.code)"
            [type]="iconTypes.CLOSE"></app-custom-icons>
          </div>
        }
        <div class="cx-order-history-sort bottom row">
          @if (products.pagination.totalPages > 1) {
            <div class="cx-order-history-pagination">
              <cx-pagination [pagination]="pagination" (viewPageEvent)="pageChange($event)"></cx-pagination>
            </div>
          }
        </div>
      } @else {
        {{'saveForLaterItems.productsEmpty' | cxTranslate}}
      }
    } @else {
      <div class="cx-spinner">
        <cx-spinner></cx-spinner>
      </div>
    }
  </div>
</div>
